import type React from "react";
import { type FC, type ReactNode } from "react";
import { Badge, Box, styled } from "@schaeffler-commerce/design-system";

const StyledListItem = styled("div", {
  shouldForwardProp: (prop) => prop !== "$isActive" && prop !== "$isNotification",
})<{ $isActive?: boolean; $isNotification?: boolean }>(({ theme, $isActive, $isNotification }) => ({
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: 50,
  height: "100%",
  padding: "0 4px",
  color: $isActive ? theme.palette.primary.main : theme.palette.text.primary,
  borderTop: $isActive ? `3px solid ${theme.palette.primary.main}` : undefined,
  "& .MuiBadge-badge": {
    ...theme.typography.labelMedium,
    fontWeight: "bold",
    top: 6,
    right: -4,
    boxShadow: "none !important",
    backgroundColor: $isNotification ? theme.palette.salesCampaign.main : theme.palette.primary.main,
    color: `${theme.palette.common.white} !important`,
  },
}));

interface BottomNavigationItemProps {
  name: string;
  icon?: ReactNode;
  isActive?: boolean;
  isNotification?: boolean;
  quantity?: string | number;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  "data-test-id"?: string;
}

export const BottomNavigationItem: FC<BottomNavigationItemProps> = (props) => (
  <StyledListItem
    $isActive={props.isActive}
    $isNotification={props.isNotification}
    onClick={props.onClick}
    data-test-id={props["data-test-id"]}
  >
    <>
      <Badge badgeContent={props.quantity ? props.quantity : null}>{props.icon && props.icon}</Badge>
      {props.name && <Box className={"label-medium f-no-wrap"}>{props.name}</Box>}
    </>
  </StyledListItem>
);
